import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useTable } from 'hooks'
import { departments } from 'orm'
import { getColumns } from './model'

import { toDepartments } from 'ducks/router'
import type { TableQuery } from 'hooks/useTable'

const useDepartmentListingTableMutations = () => {
  const dispatch = useDispatch()

  const handleFetchDepartments = React.useCallback(
    ({ limit, offset, ordering, search }: TableQuery) => {
      dispatch(departments.fetchStart({ limit, offset, ordering, search }))
    },
    [dispatch],
  )

  return {
    handleFetchDepartments,
  }
}

const useDepartmentListingTableData = () => {
  const data = useSelector(departments.getModel)

  const { count, items = [], order = [] } = data ?? {}

  return {
    state: { count, items, order },
  }
}

export const useDepartmentListingTable = state => {
  const { mapSortingPropToQueryParam, search } = state

  const columns = getColumns()

  const dispatch = useDispatch()

  const { handleFetchDepartments } = useDepartmentListingTableMutations()

  const {
    state: { count, items, order },
  } = useDepartmentListingTableData()

  const handleRefetch = React.useCallback(
    ({ limit, offset, ordering, search }: TableQuery) => {
      handleFetchDepartments({ limit, offset, ordering, search })
    },
    [handleFetchDepartments],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, offset, ordering, search }: TableQuery) => {
      dispatch(toDepartments(null, { limit, offset, ordering, search }))
    },
    [dispatch],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: order.map(key => items[key]),
    mapSortingPropToQueryParam,
    pageCount: count,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
